type LoadingProps = {
    isFullScreen?: boolean;
    message?: string;
};

export const Loading = ({ isFullScreen = false, message = "読み込み中..." }: LoadingProps) => {
    return (
        <div
            className={`flex flex-col items-center justify-center bg-github-canvas p-4 ${
                isFullScreen ? "fixed inset-0" : "h-full w-full"
            }`}
        >
            <div className="rounded-md bg-github-canvas-subtle p-8 shadow-lg">
                <div className="flex items-center space-x-4">
                    <div className="h-8 w-8 animate-spin rounded-full border-4 border-github-accent border-t-transparent" />
                    <p className="text-lg font-medium text-github-fg">{message}</p>
                </div>
            </div>
        </div>
    );
};
